<template>
  <base-draggable-modal
      name="custom_permissions"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="custom_permissions">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-row>
              <v-col>
                <v-autocomplete
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    density="default"
                    v-model="record.user_id"
                    :items="$lodash.sortBy(users, 'name')"
                    :return-object="false"
                    item-value="id"
                    item-title="name"
                    @update:model-value="showPermissions"
                    hide-details
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('user') }}<strong>*</strong></span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox :disabled="global_permissions.show" density="compact" color="success" hide-details v-model="record.show" :label="$store.getters.translate('show')"/>
              </v-col>
              <v-col>
                <v-checkbox :disabled="global_permissions.edit" density="compact" color="success" hide-details v-model="record.edit" :label="$store.getters.translate('edit')"/>
              </v-col>
              <v-col>
                <v-checkbox :disabled="global_permissions.delete" density="compact" color="success" hide-details v-model="record.delete" :label="$store.getters.translate('delete')"/>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["selected_model"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      page: helpFunctions.pages.custompermissions,
      all_records: [],
      users: [],
      record: {},
      global_permissions: {}
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(model_type, model_id) {
      this.record = {
        user_id: null,
        model_id: model_id,
        model_type: model_type,
        show: false,
        edit: false,
        delete: false,
      };
      this.openModal('custom_permissions');
      this.global_permissions = { show: false, edit: false, delete: false };
      await this.getUsers();
      await this.getCustomPermissions();
    },
    async getUsers() {
      this.users = await helpFunctions.getFullAdditionalModels(this.$toast, "user", true);
    },
    async getCustomPermissions() {
      this.all_records = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?model_type=" + this.record.model_type + "&model_id=" + this.record.model_id, true);
      if (this.record.user_id) {
        this.showPermissions();
      }
    },
    showPermissions() {
      this.record.show = false;
      this.record.edit = false;
      this.record.delete = false;
      let custom_permission = this.all_records.find(permission => permission.user_id === this.record.user_id);
      if(custom_permission) {
        this.record.show = custom_permission.show;
        this.record.edit = custom_permission.edit;
        this.record.delete = custom_permission.delete;
      }
      //CHECK IF THE USER HAS PERMISSIONS BECAUSE OF HIS ROLE
      this.global_permissions = { show: false, edit: false, delete: false };
      let selected_user = this.users.find(user => user.id === this.record.user_id);
      if(selected_user && selected_user.assign_permission.includes("show_" + this.selected_model)) {
        this.record.show = true;
        this.global_permissions.show = true;
      }
      if(selected_user && selected_user.assign_permission.includes("edit_" + this.selected_model)) {
        this.record.edit = true;
        this.global_permissions.edit = true;
      }
      if(selected_user && selected_user.assign_permission.includes("delete_" + this.selected_model)) {
        this.record.delete = true;
        this.global_permissions.delete = true;
      }
    },
    async save() {
      if (!this.record.user_id) {
        this.$toast.error(this.$store.getters.translate("please_select_user"));
      }
      else {
        //NO NEED TO GIVE CUSTOM PERMISSIONS IF THE USER ALREADY HAS GLOBAL PERMISSIONS BECAUSE OF HIS ROLE
        this.record.show = this.global_permissions.show ? false : this.record.show;
        this.record.edit = this.global_permissions.edit ? false : this.record.edit;
        this.record.delete = this.global_permissions.delete ? false : this.record.delete;
        await helpFunctions.createModel(this.$toast, this.page.name, this.record);
        await this.getCustomPermissions();
      }
    },
    reset() {
      this.all_records = [];
      this.record = {};
      this.global_permissions = {};
      this.closeModal('custom_permissions');
    },
  },
};
</script>